import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	summaryPlaceholder: {
		id: 'native-issue-table.common.issue-create-form.summary.summary-placeholder',
		defaultMessage: 'What needs to be done?',
		description: 'Placeholder text shown for the summary textarea.',
	},
	summaryLabel: {
		id: 'native-issue-table.common.issue-create-form.summary.summary-label',
		defaultMessage: 'Summary',
		description: 'Label to be used by assistive technologies for the summary textarea.',
	},
});
